import React from 'react';
/*
To import child routes, insert the following code:
import { <childComponent>Routes } from './components/<child-folder>';
*/

import { Route } from '@plasma/ui.application.router';

const TopBarThemed = React.lazy(() => import('.'));

export const topBarThemedRoutes = [
  new Route({
    path: 'top-bar-themed',
    element: TopBarThemed,
    children: [],
  }),
];
